import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { DecryptPipe } from "../app/auth/_services/encrypt-decrypt.pipe";

@Injectable()
export class HttpClient {
  constructor(
    private http: Http,
    private cookieservice: CookieService,
    private decryptpipe: DecryptPipe
  ) {}

  createAuthorizationHeader(headers: Headers) {
    if (this.cookieservice.get("user_access_token")) {
      // if (localStorage.getItem('token') !== undefined) {
      let user_access_token = this.decryptpipe.transform(
        JSON.parse(this.cookieservice.get("user_access_token"))
      );
      const token: string = "Bearer " + user_access_token;
      headers.append("Authorization", token);
    }
    //  headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append("Content-Type", "application/json; charset=utf-8");
  }

  get(url) {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(url, {
      headers: headers,
    });
  }

  post(url, data) {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.post(url, data, {
      headers: headers,
    });
  }

  file(url, data, options) {
    const headers = new Headers();
    return this.http.post(url, data, options);
  }
}
